import { render } from "./ContactBooksGroup.vue?vue&type=template&id=4156f130"
import script from "./ContactBooksGroup.vue?vue&type=script&lang=js"
export * from "./ContactBooksGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__